import React, { useState } from "react";
import "./import_feuille.css";
import { apiFetch } from "../../config";

function ImportFeuille({ prof, semaine }) {
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleImport = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!prof || !semaine) {
      setMessage("Veuillez sélectionner un professeur et une semaine.");
      e.target.value = "";
      return;
    }

    const formData = new FormData();
    formData.append("image", file);
    formData.append("prof", prof);
    formData.append("semaine", semaine);

    setLoading(true);
    setMessage("");
    try {
      const response = await apiFetch("/import_feuille_main", {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      setMessage(data.message);
    } catch {
      setMessage("Erreur lors de l'import.");
    } finally {
      setLoading(false);
      e.target.value = "";
    }
  };

  return (
    <div className="import-feuille">
      <label className="import-btn">
        {loading ? "Traitement..." : "Importer une feuille scannée"}
        <input type="file" accept="image/*,.pdf" onChange={handleImport} disabled={loading} />
      </label>
      {message && <p className="import-message">{message}</p>}
    </div>
  );
}

export default ImportFeuille;
